<svg [floatUi]="popperContent"
     [showOnStart]="false"
     [showTrigger]="NgxFloatUiTriggers.hover"
     hideOnClickOutside
     [hideOnScroll]="true"
     [applyClass]="'popperApplyClass'"
     [placement]="position() === 'right' ? NgxFloatUiPlacements.RIGHT : NgxFloatUiPlacements.LEFT">
  <use xlink:href="assets/project-icons/help.svg#c"></use>
</svg>

<float-ui-content #popperContent>
  @if (title()) {
    <div class="general-big-text">{{title()}}</div>
  }
  @for (par of paragraphs(); track par) {
    <div class="general-text" style="min-width: 200px">{{par}}</div>
  }
</float-ui-content>
